/**
 * Flags de funcionalidades fora do escopo de lançamento
 * (docs/ESCOPO-LANCAMENTO.md, seção 2). O código continua no repositório;
 * só rotas e itens de menu ficam ocultos enquanto a flag for false.
 */
export const FEATURES = {
  /** Criador de posts / sticker cards (figurinhas) */
  stickerCards: false,
  /** Ranking público e temporadas */
  ranking: false,
} as const;
